
let config_lineChartEV = {
    colors: [],
    credits: {
        enabled: false
    },
    title: {
        text: '' // leave empty to hide title
    },
    chart: {
        type: 'scatter',
        height: 500,
        zoomType: 'x',
        ignoreHiddenSeries: true,
        spacing: [31,0,31,0],
        backgroundColor: '#EEECE9'
    },
    legend: {
        enabled: false
    },
    xAxis: {
        reversed: false,
        categories: [],
        crosshair: {
            enabled: false,
        },
        labels: {
            enabled: false
        }
    },

    yAxis: {
        max: 50,
        min: 0,
        title: {
            text: 'Percent'
        },
        labels: {
            format: "{value} %"
        },
    },
    tooltip: {
        split: true,
        distance: 50,
    },
    plotOptions: {
        spline: {
            tooltip: {
                pointFormat: '{point.series.name}, {point.y} %',
                split: true,
            },
        },
        scatter: {
            tooltip: {
                headerFormat: '{point.series.date}',
                pointFormat: '{point.series.name}, {point.y} %',
            },

        },
    },
    series: []
}

let config_lineChartInt = {
    colors: [],
    credits: {
        enabled: false
    },
    title: {
        text: '' // leave empty to hide title
    },
    chart: {
        type: 'scatter',
        height: 500,
        zoomType: 'x',
        ignoreHiddenSeries: true,
    },
    xAxis: {
        reversed: false,
        categories: [],
        crosshair: {
            enabled: true,
        }
    },

    yAxis: {
        max: 55,
        min: 0,
        title: {
            text: 'Percent'
        },
        labels: {
            format: "{value} %"
        },
    },
    tooltip: {
        split: true,
        distance: 50,
    },
    plotOptions: {
        spline: {
            tooltip: {
                pointFormat: '{point.series.name}, {point.y} %',
            },
        },
        scatter: {
            tooltip: {
                headerFormat: '{point.series.date}',
                pointFormat: '{point.series.name}, {point.y} %',
            },

        },
    },
    series: []
};

const diagramsConfigInit = (parties, type) => {
    parties.forEach((party, index) => {
        let partyName = "";
        let partyColor = "";
        if (type === 'intention') {
            if (party.id < 7) {
                partyName = party.label
                partyColor = party.color
            }
            if (party.id === 7) {
                partyName = "Λ-Α-Α";
                partyColor = "#d2d2d2";
            }
            config_lineChartInt.series.push(
                {
                    //Scatter
                    type: "scatter",
                    name: partyName,
                    data: [],
                    opacity: 0.3,
                    enableMouseTracking: false,
                    showInLegend: false,
                    color: partyColor,
                    marker: {
                        enabled: true,
                        symbol: "round",
                        radius: 3,
                        fillColor: partyColor,
                    },
                },
                {
                    // Regression line
                    type: "spline",
                    name: partyName,
                    data: [],
                    showInLegend: true,
                    lineColor: partyColor,
                    color: partyColor,
                    marker: {
                        enabled: false,
                        symbol: "round",
                        fillColor: partyColor,
                    }
                }
            );
        }
        if (type === 'evaluation') {
            if (party.id < 7) {
                partyName = party.label
                partyColor = party.color
            }
            // if (party.id === 7) {
            //     partyName = "AΛΛΟ";
            //     partyColor = "#999999";
            // }

            config_lineChartEV.series.push(
                {
                    //Scatter
                    type: "scatter",
                    name: partyName,
                    data: [],
                    opacity: 0.3,
                    enableMouseTracking: false,
                    showInLegend: false,
                    color: partyColor,
                    marker: {
                        enabled: true,
                        symbol: "round",
                        radius: 3,
                        fillColor: partyColor,
                    },
                },
                {
                    // Regression line
                    type: "spline",
                    name: partyName,
                    data: [],
                    showInLegend: true,
                    lineColor: partyColor,
                    color: partyColor,
                    marker: {
                        enabled: false,
                        symbol: "round",
                        fillColor: partyColor,
                    }
                }
            );
        }
    })
}

export  {diagramsConfigInit, config_lineChartEV, config_lineChartInt}